import { BaseContextType, SchemaModelType } from '@smx-ui-model/types';

import { createDrawingSetAnnotationMutation } from '../graphql/mutation/create-drawing-set-annotation-mutation';
import { deleteDrawingSetAnnotationMutation } from '../graphql/mutation/delete-drawing-set-annotation-mutation';
import { updateDrawingSetAnnotationMutation } from '../graphql/mutation/update-drawing-set-annotation-mutation';
import { getDrawingSetAnnotationListQuery } from '../graphql/query/get-drawing-set-annotation-list-query';
import { getDrawingSetAnnotationQuery } from '../graphql/query/get-drawing-set-annotation-query';
import schema from '../schema-generated.json';
import { DrawingSetAnnotationModelSchemaType, DrawingSetAnnotationModelType } from './types';

export const drawingSetAnnotationCoreModel: DrawingSetAnnotationModelSchemaType<BaseContextType> = {
    label: 'Drawing Set Annotation',
    name: 'annotation',
    queryList: getDrawingSetAnnotationListQuery,
    queryOne: getDrawingSetAnnotationQuery,
    mutation: {
        create: createDrawingSetAnnotationMutation,
        update: updateDrawingSetAnnotationMutation,
        delete: deleteDrawingSetAnnotationMutation,
    },
    context: {
        inspectorInput: ['drawingSetId', 'drawingSheetId', 'type', 'xfdf'],
    },
    schema: schema.DrawingSet as unknown as SchemaModelType<DrawingSetAnnotationModelType>,
};
